<template>
  <div class="container mt-5">
    <h3 class="mb-4">链接状态管理</h3>

    <!-- 搜索框 + 刷新按钮 -->
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="输入链接关键字搜索..."
            v-model="searchKeyword"
            @click="doSearch"
          />
          <!-- 搜索按钮（点击也触发搜索） -->
          <div class="input-group-append">
            <button
              class="btn btn-primary"
              @click="doSearch"
              :disabled="!searchKeyword"
            >
              <i class="bi bi-search"></i> 搜索
            </button>
          </div>
          <div class="input-group-append" v-if="searchKeyword">
            <button class="btn btn-outline-secondary" @click="reset">
              清空
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 text-right">
        <button class="btn btn-primary" @click="fetchData">
          <i class="bi bi-arrow-clockwise"></i> 刷新列表
        </button>
      </div>
    </div>
    <!-- 统计信息 -->
    <div class="alert alert-info d-inline-block" style="padding: 0.4rem 0.8rem">
      共 {{ filteredList.length }} 条链接 （正常：{{ normalCount }}，已拒绝：{{
        rejectCount
      }}）
    </div>
    <!-- 控制比例部分（优化后） -->
    <div class="card mt-4 shadow-sm">
      <div class="card-header bg-primary text-white">
        <h4 class="mb-0">控制比例</h4>
      </div>
      <div class="card-body">
        <!-- 滑动条 + 当前值显示 -->
        <div class="row align-items-center mb-3">
          <div class="col-md-8">
            <label class="form-label font-weight-bold"
              >调整比例：{{ rateValue }}% : {{ 100 - rateValue }}%</label
            >
            <input
              type="range"
              class="form-range"
              min="0"
              max="100"
              step="1"
              v-model="rateValue"
            />
          </div>
          <div class="col-md-4 text-md-right">
            <button class="btn btn-primary px-4" @click="applyRatio">
              {{ settingSubmitting ? "设置中..." : "应用设置" }}
            </button>
          </div>
        </div>
        <small class="text-muted mt-2 d-block">
          拖动滑块调整比例，点击“应用设置”后生效。
        </small>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table-responsive">
      <table class="table table-striped table-hover table-bordered mt-3">
        <thead class="thead-dark">
          <tr>
            <th width="60">序号</th>
            <th>链接</th>
            <th>备注</th>
            <th width="100" class="text-center">状态</th>
            <th width="120" class="text-center">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredList" :key="item.link">
            <td>{{ index + 1 }}</td>
            <td>
              <a>
                {{ item.link }}
              </a>
            </td>
            <td>{{ item.remark }}</td>
            <td class="text-center">
              <span
                :class="
                  item.state === 1
                    ? 'text-success font-weight-bold'
                    : 'text-danger font-weight-bold'
                "
              >
                {{ item.state === 1 ? "正常" : "已拒绝" }}
              </span>
            </td>
            <td class="text-center">
              <button
                v-if="item.state === 1"
                class="btn btn-sm btn-warning"
                @click="changeState(item.link, 0)"
                :disabled="loadingLinks.includes(item.link)"
              >
                {{ loadingLinks.includes(item.link) ? "处理中..." : "拒绝" }}
              </button>
              <button
                v-else
                class="btn btn-sm btn-success"
                @click="changeState(item.link, 1)"
                :disabled="loadingLinks.includes(item.link)"
              >
                {{ loadingLinks.includes(item.link) ? "处理中..." : "恢复" }}
              </button>
              <!-- 新增备注按钮 -->
              <button
                class="btn btn-sm btn-info text-white"
                @click="openRemarkModal(item)"
                :disabled="loadingLinks.includes(item.link)"
              >
                <i class="bi bi-chat-dots"></i> 备注
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 备注编辑 Modal -->
    <div
      class="modal fade in"
      id="remarkModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">编辑备注</h5>
            <button
              type="button"
              class="dialog-close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeRemarkModal"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">链接</label>
              <input
                type="text"
                class="form-control"
                :value="editingLink"
                disabled
              />
            </div>
            <div class="mb-3">
              <label class="form-label"
                >备注 <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                v-model="editingRemark"
                placeholder="请输入备注（必填）"
                autocomplete="off"
                ref="remarkInput"
                :class="{ 'is-invalid': remarkError }"
              />
              <div class="invalid-feedback" v-if="remarkError">
                备注不能为空
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="closeRemarkModal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="submitRemark"
              :disabled="remarkSubmitting"
            >
              {{ remarkSubmitting ? "提交中..." : "提交" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkData: {}, // 原始数据 { "https://xxx": 1 }
      filteredList: [], // 过滤后的数组形式
      searchKeyword: null, // 搜索关键词
      loadingLinks: [], // 正在操作的链接
      editingLink: "", // 当前正在编辑的链接
      editingRemark: "", // 输入框里的备注内容
      remarkError: false, // 必填校验
      remarkSubmitting: false, // 提交状态
      rateValue: 0,
      settingSubmitting: false,
    };
  },
  computed: {
    // 统计数量
    normalCount() {
      return this.filteredList.filter((i) => i.state === 1).length;
    },
    rejectCount() {
      return this.filteredList.filter((i) => i.state !== 1).length;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 打开备注弹窗（Vue 2 + Bootstrap 4 正确写法）
    openRemarkModal(item) {
      this.editingLink = item.link;
      this.editingRemark = item.remark || "";
      this.remarkError = false;
      let modal = document.getElementById("remarkModal");
      modal.classList.add("show");
      modal.style.display = "block";
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("role", "dialog");
    },
    closeRemarkModal() {
      this.editingLink = "";
      this.editingRemark = "";
      let modals = document.getElementsByClassName("modal fade in");
      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove("show");
        modals[i].style.display = "none";
        modals[i].removeAttribute("aria-modal");
        modals[i].removeAttribute("role");
      }
    },

    async applyRatio() {
      this.settingSubmitting = true;
      try {
        const res = await this.$axios({
          method: "put",
          url: "/api/manage/update/rateNum/" + this.rateValue, // 改成你的实际接口
        });
        if (res.data.code === 200) {
          this.fetchData(); // 刷新列表
          alert("设置成功");
        }
      } catch (err) {
        console.error(err);
        alert("设置失败");
      } finally {
        this.settingSubmitting = false;
      }
    },

    // 提交备注
    async submitRemark() {
      if (!this.editingRemark) {
        this.remarkError = true;
        return;
      }
      this.remarkError = false;
      this.remarkSubmitting = true;

      try {
        await this.$axios({
          method: "put",
          url: "/api/manage/update/remark", // 改成你的实际接口
          data: {
            link: this.editingLink,
            remark: this.editingRemark,
          },
        });

        this.fetchData(); // 刷新列表
        this.closeRemarkModal();
      } catch (err) {
        console.error(err);
        alert("备注保存失败");
      } finally {
        this.remarkSubmitting = false;
      }
    },
    doSearch() {
      this.fetchData();
    },
    reset() {
      this.searchKeyword = null;
      this.fetchData();
    },
    // 获取原始数据
    async fetchData() {
      let data = { search: this.searchKeyword };
      try {
        const res = await this.$axios({
          method: "post",
          url: "/api/manage/list",
          data: data,
        }); // 改成你的接口
        if (res.data.code === 200) {
          let res1 = res.data.data;
          this.linkData = res1.list;
          this.rateValue = res1.rateNum;
          this.filteredList = this.linkData;
        }
      } catch (err) {
        console.error(err);
        alert("加载失败");
      }
    },

    // 修改状态
    async changeState(link, newState) {
      if (this.loadingLinks.includes(link)) return;
      this.loadingLinks.push(link);

      try {
        const res = await this.$axios({
          method: "put",
          url: "/api/manage/update/state",
          data: { link: link, state: "" + newState },
        });
        console.log(res);
        this.fetchData();
      } catch (err) {
        console.error(err);
        alert("操作失败");
      } finally {
        this.loadingLinks = this.loadingLinks.filter((l) => l !== link);
      }
    },
  },
};
</script>

<style scoped>
.text-break {
  word-break: break-all;
}
.bi {
  font-family: "bootstrap-icons" !important;
}
</style>